import { Injectable } from '@angular/core';

import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { LocalStoreService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class BestOddsHelpService {
    private storageKey = 'helpBoxClosed';

    constructor(
        private racingConfig: RacingConfig,
        private localStorage: LocalStoreService,
    ) {}

    get shouldShowHelpBox(): boolean {
        return this.racingConfig.isBOGEnabled && !this.localStorage.get(this.storageKey);
    }

    setHelpBoxClosed(): void {
        this.localStorage.set(this.storageKey, true);
    }
}
